<section>
  @if (currentlyEditingLawName) {
    <h3 class="h4 bold">{{currentlyEditingLawName}}</h3>
  } @else {
    <h3 class="h4 bold">New Law</h3>
  }
  <form [formGroup]="form" class="grid-container">
    <div class="grid-x grid-margin-x">
      <div class="cell large-6">
        <label for="name" class="required">
          Law Name:
          <input type="text" formControlName="name" id="name" />
        </label>
        <label for="ORC" class="required">
          ORC/OAC number:
          <input type="text" formControlName="ORC" id="ORC" />
        </label>
        <label for="updatedBy">
          Updated By:
          <input type="text" id="updatedBy" formControlName="updatedBy" />
        </label>
      </div>
      <div class="cell large-6">
        <div>
          <div class="grid-x grid-margin-x">
            <label for="url" class="cell large-9">
              Relative URL:
              <input type="text" id="url" formControlName="url" #relativeUrl />
            </label>
            <button class="button copy-btn cell large-3" (click)="copyValueToClipboard(relativeUrl)">
              Copy
            </button>
          </div>
          <div class="grid-x grid-margin-x">
            <label class="cell large-9" for="directurl">
              Direct URL:
              <input type="text" id="directurl" formControlName="directurl" #directUrl />
            </label>
            <button class="button copy-btn cell large-3" (click)="copyValueToClipboard(directUrl)">
              Copy
            </button>
          </div>
        </div>
        <label for="updatedDate">
          Last Updated:
          <input type="text" id="updatedDate" formControlName="updatedDate" [value]="form.get('updatedDate').value | date:'full'" />
        </label>
      </div>
      <div class="cell large-12 form-button-group text-align-center">
        <button class="button margin-right" (click)="cancel()">Cancel</button>
        <button [disabled]="form.invalid" class="button" (click)="save()">Save</button>
      </div>
      <div class="cell">
        <label for="content" class="required">
          Law Content:
          <textarea [froalaEditor]="editorOptions" formControlName="content"></textarea>
        </label>
      </div>
      <div class="cell form-button-group">
        <button class="button margin-right" (click)="cancel()">Cancel</button>
        <button [disabled]="form.invalid" class="button" (click)="save()">Save</button>
      </div>
    </div>
  </form>
</section>